import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/vhosts/dailyneedsproducts.com/httpdocs/node_modules/next/dist/client/app-dir/link.js");
